import { render } from "./sparepart-type-tree.vue?vue&type=template&id=8bf80786&ts=true"
import script from "./sparepart-type-tree.vue?vue&type=script&lang=ts"
export * from "./sparepart-type-tree.vue?vue&type=script&lang=ts"

import "./sparepart-type-tree.vue?vue&type=style&index=0&id=8bf80786&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__